import { Box, Button, Typography, Modal } from '@mui/material';
import * as React from 'react'
import { Draft, Player, Team } from '../../../../sdk/model';
import { getCurrentSalary, toSalary } from '../../../util/SalaryDisplay';
import DraftPickCard from '../../../cards/draftPickCard';

interface draftPickModalProps {
  leagueId: string,
  draft: Draft | undefined,
  playerMap: Map<string | undefined, Player | undefined> | undefined,
  teamMap: Map<string | undefined, Team>,
  currentRound: number,
  currentPick: number,
  currentSeasonYear: number,
  myTeam: Team | undefined
}

function DraftPickModal(props: draftPickModalProps) {
  const [viewingPick, setViewingPick] = React.useState(undefined);
  
  const connectedUserIds = new Set(props.draft?.connectedUserIds);
  return <Box sx={{ display: 'inline-block', whiteSpace: 'nowrap', overflowX: 'auto'}}>
    <Modal open={viewingPick} onClose={() => setViewingPick(undefined)} 
        aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description"
        sx={{margin: '5%'}}>
      <DraftPickCard pick={viewingPick} leagueId={props.leagueId} />
    </Modal>
    {Object.entries(props.draft?.draftPicks).map(([roundIndex, round]) => {
    const roundNumber = Number(roundIndex) + 1;
    return <Box key={roundIndex} sx={{ display: 'inline' }}>
        {round?.some(pick => !pick.contract.playerId) && <Typography variant="body" component="span" color="text.secondary" sx={{ flexGrow: 1, fontSize: 16 }}>
          Round {roundNumber}:
        </Typography>}
        {Object.entries(round).map(([pickIndex, pick]) => {
          if (pick?.contract?.playerId) {
          return null;
          } else if (pick?.teamId === null) {
            return <Typography variant="body" component="span" color="text.secondary" sx={{ flexGrow: 1, fontSize: 16 }}>Pick is null</Typography>
          }
          const pickNumber = pick?.pickNumber!;
          const isCurrentPick = props.currentRound === roundNumber && props.currentPick === pickNumber
          const selectingTeam = props.teamMap.get(pick?.teamId);
          const teamConnected = selectingTeam && selectingTeam.owners.some(owner => connectedUserIds.has(owner.id));
          const myPick = props.myTeam && props.myTeam.id == pick?.teamId;
          const originalTeam = props.teamMap.get(pick.originalTeamId);
          return <Box key={pickIndex} sx={{ display: 'inline-block' }}>
            <Typography variant="body" component="span" color="text.secondary" sx={{ flexGrow: 1, fontSize: 16 }}>
              {roundNumber}.{String(pickNumber).padStart(2, '0')}
            </Typography>
            <br/>
            <Button color={myPick ? "primary" : "secondary"} className={isCurrentPick ? "current-pick" : ""} variant="contained" onClick={() => setViewingPick(props.teamMap.get(pick.teamId)!.draftPicks!.find(draftPick => draftPick.id === pick.id))}>
              <Box>
                <b>{selectingTeam ? selectingTeam.name : 'DELETED TEAM'}</b> <Typography title={teamConnected ? "Connected" : "Not Connected"} sx={{display: 'inline-block', fontSize: 'xx-large', color : (teamConnected ? "darkgreen" : "darkred")}}>●</Typography> {pick.teamId !== pick.originalTeamId && "(via " + (originalTeam ? originalTeam.name : 'DELETED TEAM') + ")"}
                <br/>
                {toSalary(pick?.contract?.totalSalary)}/{pick.contract.numberOfSeasons}yrs, {toSalary(pick.contract.averageAnnualSalary)} APY
                <br/>
                {getCurrentSalary(pick!, props.currentSeasonYear)} {props.currentSeasonYear}
              </Box>
            </Button>
          </Box>
        })}
      </Box>
    })}
  </Box>
}

export default DraftPickModal;